import {Component, Input} from '@angular/core';
import {BaseModalComponent} from "app/views/modal/base_modal.component";
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {SupportService} from "../support.service";
import {ModalSpreaderService} from "./modal_spreader_service";
import {AbstractControl, FormControl, FormGroup, ValidatorFn, Validators} from "@angular/forms";
import * as moment from 'moment-timezone';
import { environment } from 'environments/environment';
import {BaseFormGroup} from "../../../models/form";
import { FormControlValidators } from "../../../models/validators/validator";


@Component({
	selector: 'base-support-modal',
	template: `<base-modal
		[title]="title"
		[isLoading]="isLoading"
		[btnOkClass]="btnOkClass"
		[btnOkLabel]="btnOkLabel"
		[isBtnOkActive]="isBtnOkActive"
		[form]="form"
		(onOk)="ok()"
	>
		<form [formGroup]="form">
			<ng-content></ng-content>

			<div class="form-group">
				<label>
					Комментарий
				</label>
				
				<textarea
					placeholder="Комментарий обязателен"
					class="form-control"
					formControlName="comment"
					[(ngModel)]="_comment"
					[formErrorIndicator]="form.get('comment')"
				></textarea>

				<br *ngIf="errors.length > 0" />
				<div *ngFor="let error of errors" class="alert alert-danger" role="alert">{{ error }}</div>
			</div>
		</form>
	</base-modal>`
})
export class BaseSupportModalComponent extends BaseModalComponent {
	public _comment: string = (!environment.SEXTANT && !environment.PRODUCTION) ? 'Тестирование админки' : '';
	
	get comment(): string {
		return this.spreader.base._comment;
	}

	set comment(value: string) {
		this.spreader.base._comment = value;
	}

	public isBtnOkActive: boolean = true;
	public errors: string[] = [];

	@Input() form: BaseFormGroup = new BaseFormGroup({});
	
	constructor(public activeModal: NgbActiveModal, public supportService: SupportService, public spreader: ModalSpreaderService) {
		super(activeModal);
		
		//spreader - фиксер кривого наследования
		if (this.spreader.child == null) {
			this.spreader.child = this;
		} 
		
		this.spreader.base = this;
		
		if (this.constructor.name == 'SetDivlyIdModalComponent') {
			
		}
	}
	
	ngOnInit() {
		this.form.addControl(
			'comment',
			new FormControl(this.comment, [
				FormControlValidators.required(),
				FormControlValidators.minLength(10),
			])
		);
		
		this.form.statusChanges.subscribe(status => {
			if (status === 'VALID') {
				this.errors = [];
			}
		});
	}

	validate() {
		this.errors = [];
		
		if (this.form.status === 'VALID') {
			return true;
		}

		for (let keyC of Object.keys(this.form.controls)) {
			let errors = this.form.controls[keyC].errors;
			if (errors != null) {
				for (let keyE of Object.keys(errors)) {
					let error = errors[keyE];
					if (error.message) {
						this.errors.push(error.message);
					} else {
						this.errors.push(keyE);
					}
				}
			}
		}
		
		return false;
	}

	ok() {
		if (this.validate()) {
			this.onOk.emit();
		}
	}

	execute() {
		this.activeModal.close('OK');
	}

	getCustomValidator(name: string, f: any): ValidatorFn {
		return (control: AbstractControl): { [key: string]: any } | null => {
			return f(name, control);
		}
	}

	getStandartValidator(name: string, validator: ValidatorFn, message: string): ValidatorFn {
		return (control: AbstractControl): { [key: string]: any } | null => {
			const isInvalid = validator(control);

			let err = {};
			err[name] = {value: control.value, message: message};

			return isInvalid != null ? err : null;
		}
	}
	
	public CustomValidators = {
		dateFormat: function (format: string): ValidatorFn {
			return function (control: AbstractControl) {
				if (!control.value) {
					return null;
				}

				const isInvalid = !(moment(control.value, format, true).isValid());

				return isInvalid ? {'dateFormat': {'requiredFormat': format, 'actualFormat': control.value}} : null;
			};
		},
		dateNotBeforeToday: function (format: string): ValidatorFn {
			return function (control: AbstractControl) {
				if (!control.value) {
					return null;
				}

				const dt = moment(control.value, format, true);
				if (dt.isValid()) {
					const isInvalid = dt.endOf('day').isBefore();

					return isInvalid ? {'dateNotBeforeToday': {'minDate': moment().format(format), 'actualDate': dt.format(format)}} : null;
				}

				return null;
			};
		},
	};
}
